module.exports = __webpack_public_path__ + "img/testimonio.d61c60e7.png";